import React from 'react';
import { Heart } from 'lucide-react';
import CatalogProductImage from './CatalogProductImage';

/**
 * ChatProductCard — THE product-recommendation card for chat.
 *
 * Single source of truth for how a recommended product looks in the conversation:
 * a square product PHOTO on top, name + brand underneath, labeled save action. The
 * e-commerce/browse feel is deliberate — the photo leads, the text supports.
 *
 * This exists because the card markup used to live inline inside
 * StructuredMessage's formatProductContent, which meant every branch carried its
 * own divergent copy and the design changed depending on which one got deployed
 * (and on how many products a reply happened to contain). Change the look HERE.
 *
 * Shade matches are NOT this card — a product with 2+ known shades renders the
 * swatch trio instead (still in StructuredMessage, since it's swatch-index bound).
 */
const ChatProductCard = ({
  productName,
  brand,
  heroUrl,
  isSaved = false,
  onSave,
  canSave = false,
}) => (
  <div className="chat-product-card relative rounded-2xl border border-[#E5E0D8] bg-white p-3 flex flex-col">
    <div
      className="chat-product-card-image w-full rounded-xl overflow-hidden bg-[#F4F1EC] flex items-center justify-center mb-2.5"
      style={{ aspectRatio: '1 / 1' }}
    >
      <CatalogProductImage src={heroUrl} alt={productName} brand={brand} className="w-full h-full object-contain" />
    </div>
    <p className="chat-product-card-name text-[13.5px] font-semibold text-[#2A1212] leading-tight">{productName}</p>
    {brand && <p className="chat-product-card-brand text-[10.5px] uppercase tracking-wide text-[#2A324B]/55 mt-0.5">{brand}</p>}
    {canSave && (
      <button
        type="button"
        onClick={onSave}
        disabled={isSaved}
        className="chat-product-card-save mt-auto pt-3 flex items-center justify-center gap-1.5 text-[13px] font-semibold text-[#2A324B] hover:text-[#2A1212] disabled:opacity-70"
      >
        <Heart className="w-[17px] h-[17px]" aria-hidden="true" fill={isSaved ? '#2A324B' : 'none'} />
        {isSaved ? 'Saved' : 'Save product'}
      </button>
    )}
  </div>
);

export default ChatProductCard;
